import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MotifCard,
  MotifCardBody,
  MotifCardHeader,
  MotifErrorMessage,
  MotifIconButton,
  MotifIcon,
  MotifCheckbox,
  MotifLabel,
  MotifFormField,
  MotifInput,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";
import {
  IconoirEditPencil,
  IconoirTrash,
  IconoirArrowDown,
  IconoirArrowUp,
} from "@ey-xd/motif-icon";
import { useUpdateStatusMutation } from "@/services/stages/stagesReducer";
import "./Stages.css";
import DeleteStageStatus from "./DeleteStageStatus";
import { StatusType, OrderChange, DueDateType } from "./StagesType";
import CreateEditStatus from "./CreateEditStatus";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import {
  getOnlyDate,
  havingDeletePermission,
  havingEditPermission,
  isPastDate,
} from "@/utility/common";
import { MotifTooltip } from "@/libs/@ey-xd/motif-react/main";
import { toolTipInformationJson } from "./Constants";
import helpCircleImg from "@/features/caselist/images/help-circle.svg";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
export default function StatusTile({
  statusData,
  getStageData,
  handleOrderChange,
  setFilteredStatuses,
  filteredStatuses,
  selectedStage,
  setSelectedStage,
  ClaimStatusDefinition,
  index,
  interval,
  setInterval,
  abortController,
  setShowToast,
  showDeleteSuccessMessage,
  setShowDeleteSuccessMessage
}: {
  statusData: StatusType;
  getStageData: (isCreate: boolean) => void;
  handleOrderChange: (change: OrderChange, id: string) => void;
  numStatuses: number;
  setFilteredStatuses: (statuses: any[]) => void;
  filteredStatuses: any[];
  selectedStage: string;
  setSelectedStage: (stageId: string) => void;
  ClaimStatusDefinition: string[];
  index: number;
  interval: any;
  setInterval: any;
  abortController: any;
  setShowToast?: any;
  showDeleteSuccessMessage:any
  setShowDeleteSuccessMessage:any
}) {
  const { t } = useTranslation();
  const informationJson: any = { ...toolTipInformationJson };
  // const [inputValues, setInputValues] = useState(statusData);
  const [showCreateStatus, setShowCreateStatus] = useState(false);
  const [showDeleteStatus, setShowDeleteStatus] = useState(false);
  let delay = 500;
  const [dueDate, setDueDate] = useState(
    statusData?.timeLimitDays
      ? DueDateType.TimeLimit
      : statusData?.timeLimitDate
      ? DueDateType.Deadline
      : DueDateType.None
  );

  const [updateStatusQuery] = useUpdateStatusMutation();
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteErrorMessage, setDeleteErrorMessage] = useState({
    type: "",
    message: "",
    show: false,
  });
  const [initialStatusUsedMessage, setInitialStatusUsedMessage] = useState("");
  const pageDisable = havingEditPermission(ClaimStatusDefinition)
    ? false
    : true;
  const [deleteEntityName, setDeleteEntityName] = useState<any>("");
  const handleDocRequied = () => {
    let filteredStatuses1 = JSON.parse(JSON.stringify(filteredStatuses));
    let json: any = filteredStatuses1?.[index];

    json.isDocRequiredStatus = !json.isDocRequiredStatus;
    filteredStatuses1[index] = json;
    setFilteredStatuses(filteredStatuses1);
    if (abortController?.abort) {
      abortController.abort();
    }
    clearTimeout(interval);
    let timeOut = setTimeout(() => {
      handleInputChange1(json);
    }, delay);
    setInterval(timeOut);
  };

  const handleDueDateChange = (e: any) => {
    let filteredStatuses1 = JSON.parse(JSON.stringify(filteredStatuses));

    if (e === DueDateType.None) {
      filteredStatuses1[index].timeLimitDays = undefined;
      filteredStatuses1[index].timeLimitDate = undefined;
    } else if (e === DueDateType.TimeLimit) {
      filteredStatuses1[index].timeLimitDays = undefined;
      filteredStatuses1[index].timeLimitDate = undefined;
    } else if (e === DueDateType.Deadline) {
      filteredStatuses1[index].timeLimitDays = undefined;
      filteredStatuses1[index].timeLimitDate = undefined;
    }
    setFilteredStatuses(filteredStatuses1);
    setDueDate(e);
  };

  const handleInputChange1 = async (body: any) => {
    const requestBody: any = { ...body };
    updateStatusQuery(requestBody).then(() => {
      getStageData(false);
    });
  };

  const handleInitialStatusChange = async (keyName: any) => {
    setInitialStatusUsedMessage("");
    let changedArray: any = [];
    let filteredStatuses1 = [...filteredStatuses];
    const updatedStatuses = filteredStatuses1.map((status) => {
      if (status?.id === filteredStatuses1?.[index]?.id) {
        let jsonData: any = {
          ...status,
        };
        jsonData[keyName] = !filteredStatuses1?.[index]?.[keyName];
        changedArray.push(jsonData);
        return jsonData;
      } else if (status?.[keyName]) {
        let jsonData: any = {
          ...status,
        };
        jsonData[keyName] = false;
        changedArray.push(jsonData);
        return jsonData;
      } else {
        return status;
      }
    });

    setFilteredStatuses(updatedStatuses);
    if (abortController?.abort) {
      abortController.abort();
    }
    clearTimeout(interval);
    let timeOut = setTimeout(() => {
      let apifun = changedArray.map((statusData: any) => {
        return updateStatusQuery(statusData);
      });
      Promise.all(apifun).then(() => {
        getStageData(false);
      });
    }, delay);
    setInterval(timeOut);
  };

  function handleDateError(
    value: string,
    setErrorMessage: (msg: string) => void
  ) {
    setInterval(interval + 1);
    if (isPastDate(value)) {
      setErrorMessage("You can't use a past date as a deadline");
    } else {
      setErrorMessage("");
      // @ts-ignore
      let filteredStatuses1 = JSON.parse(JSON.stringify(filteredStatuses));
      let json: any = filteredStatuses1?.[index];
      // @ts-ignore
      json.timeLimitDate = getOnlyDate(value.toString());
      filteredStatuses1[index] = json;
      setFilteredStatuses(filteredStatuses1);
      clearTimeout(interval);
      if (abortController?.abort) {
        abortController.abort();
      }
      let timeOut = setTimeout(() => {
        handleInputChange1(json);
      }, delay);
      setInterval(timeOut);
    }
  }
  const handleStatusDeleteEvent = () => {
    setInitialStatusUsedMessage("");
    setDeleteEntityName(statusData?.name);
    setShowToast({
      type: "",
      message: "",
      show: true,
      variant: "",
    })
    setShowDeleteSuccessMessage({
      ...showDeleteSuccessMessage,
      index: index - 1,
      show: false,
      message: "",
      type: "",
    });
    setTimeout(() => {
      if (statusData.isInitialStatus) {
        setInitialStatusUsedMessage(
          t("pages.configuration.stages.initialStatusUsedMessage")
        );
      } else {
        setShowDeleteStatus(true);
      }
    }, 0);
  };
  function handleInformationIcon(keyName: string) {
    let messageString = informationJson?.[keyName]
      ? informationJson[keyName]
      : null;
    return messageString ? (
      <MotifTooltip
        variant="alt"
        placement="right"
        hideCloseButton={true}
        allowHover
        trigger={
          <div className="imgMainCon">
            <img className="imageCon" alt="tooltipimg" src={helpCircleImg} />
          </div>
        }
      >
        <span className="motif-caption-default-regular">
          {messageString.split(" ").length > 15 ? (
            <>
              {t(messageString.split(" ").slice(0, 15).join(" "))} <br />
              {t(messageString.split(" ").slice(15).join(" "))}
            </>
          ) : (
            t(messageString)
          )}
        </span>
      </MotifTooltip>
    ) : (
      <></>
    );
  }
  return (
    <>
      <div
        id={filteredStatuses?.[index]?.id}
        className="status-tile-container status-body-con"
      >
        {deleteErrorMessage.show && (
          <NotificationGrid
            show={true}
            message={deleteErrorMessage.message}
            type={deleteErrorMessage.type}
            scrollToTop={false}
            onClose={() => {
              setDeleteErrorMessage({ type: "", message: "", show: false });
            }}
          />
        )}
        {initialStatusUsedMessage && (
          <NotificationGrid
            show={true}
            message={initialStatusUsedMessage}
            type="error"
            scrollToTop={false}
            onClose={() => setInitialStatusUsedMessage("")}
          />
        )}
        <MotifCard
          className="status-tile"
          orientation="horizontal"
          variant="card-border"
        >
          <MotifCardHeader>
            <span className="motif-body1-default-bold">
              {filteredStatuses?.[index]?.name}
            </span>
            <div className="status-tile-actions">
              <div className="action-icons">
                <CommonTooltipWrapper
                  tooltipTitle={t("global.globalActions.edit")}
                >
                  <MotifIconButton
                    onClick={() => setShowCreateStatus(true)}
                    type="button"
                  >
                    <MotifIcon iconFunction={IconoirEditPencil} />
                  </MotifIconButton>
                </CommonTooltipWrapper>
                {havingDeletePermission(ClaimStatusDefinition) && (
                  <CommonTooltipWrapper
                    tooltipTitle={t("global.globalActions.delete")}
                  >
                    <MotifIconButton
                      onClick={handleStatusDeleteEvent}
                      type="button"
                    >
                      <MotifIcon iconFunction={IconoirTrash} />
                    </MotifIconButton>
                  </CommonTooltipWrapper>
                )}
              </div>
              {havingEditPermission(ClaimStatusDefinition) && (
                <div className="arrow-icons">
                  <CommonTooltipWrapper
                    tooltipTitle={t("global.globalActions.moveUp")}
                  >
                    <MotifIconButton
                      onClick={() =>
                        handleOrderChange(OrderChange.Up, statusData.id!)
                      }
                      type="button"
                      size="small"
                    >
                      <MotifIcon iconFunction={IconoirArrowUp} />
                    </MotifIconButton>
                  </CommonTooltipWrapper>
                  <CommonTooltipWrapper
                    tooltipTitle={t("global.globalActions.moveDown")}
                  >
                    <MotifIconButton
                      onClick={() =>
                        handleOrderChange(OrderChange.Down, statusData.id!)
                      }
                      type="button"
                      size="small"
                    >
                      <MotifIcon iconFunction={IconoirArrowDown} />
                    </MotifIconButton>
                  </CommonTooltipWrapper>
                </div>
              )}
            </div>
          </MotifCardHeader>
          <MotifCardBody>
            <div className="status-tile-body">
              <div className="motif-row">
                <MotifCheckbox
                  onChange={() => handleInitialStatusChange("isInitialStatus")}
                  checked={filteredStatuses?.[index]?.isInitialStatus}
                  disabled={
                    filteredStatuses?.[index]?.isInitialStatus || pageDisable
                  }
                >
                  {t("pages.configuration.stages.initialPortal")}
                  {handleInformationIcon("initialPortal")}
                </MotifCheckbox>
              </div>

              <div className="motif-row">
                <MotifCheckbox
                  onChange={() => {
                    handleDocRequied();
                  }}
                  checked={filteredStatuses?.[index]?.isDocRequiredStatus}
                  disabled={
                    pageDisable
                  }
                >
                  {t("pages.configuration.stages.requireDocument")}
                  {handleInformationIcon("requireDocument")}
                </MotifCheckbox>
              </div>
              {/* <div className="motif-row ">

              <MotifCheckbox
                onChange={() => {
                  setInputValues({
                    ...inputValues,
                    isDocReleaseStatus: !inputValues.isDocReleaseStatus,
                  });
                }}
                checked={inputValues.isDocReleaseStatus}
                disabled={pageDisable}
              >
                {t("pages.configuration.stages.releaseDocument")}{handleInformationIcon("releaseDocument")}
              </MotifCheckbox>
              
           
              </div> */}
              <div className="motif-row">
                <MotifCheckbox
                  onChange={() => {
                    handleInitialStatusChange("isResolveStatus");
                  }}
                  checked={filteredStatuses?.[index]?.isResolveStatus}
                  disabled={
                    filteredStatuses?.[index]?.isResolveStatus || pageDisable
                  }
                >
                  {t("pages.configuration.stages.resolveStatus")}
                  {handleInformationIcon("resolveStatus")}
                </MotifCheckbox>
              </div>
              <div className="motif-row">
                {/* <div className="motif-col-sm-3">
              <MotifLabel aria-label="Input" for="input">
                {t("pages.configuration.stages.portalStatus")}

                {handleInformationIcon("portalStatus")}
              </MotifLabel>
              <MotifFormField aria-label="Input" role="group">
           
                <MotifInput onChange={(e: any) =>
                    setInputValues({
                      ...inputValues,
                      portalDisplayStatus: e.target.value,
                    })
                  }
                  value={inputValues.portalDisplayStatus}
                  // onBlur={handleInputChange}
                  disabled={pageDisable}
                />
              </MotifFormField>
              </div> */}
              </div>
              <div className="motif-container">
                <div className="motif-row">
                  <div className="motif-col-sm-3">
                    <MotifFormField>
                      <MotifLabel id="select-label">
                        {t("pages.configuration.stages.dueDateType")}
                      </MotifLabel>
                      <MotifSelect
                        onChange={(e) => handleDueDateChange(e)}
                        value={dueDate}
                        disabled={pageDisable}
                      >
                        <MotifOption value={DueDateType.None}>
                          {t("global.globalPlaceholder.pleaseSelect")}
                        </MotifOption>
                        <MotifOption value={DueDateType.TimeLimit}>
                          {t("pages.configuration.stages.timeLimit")}
                        </MotifOption>
                        <MotifOption value={DueDateType.Deadline}>
                          {t("pages.configuration.stages.deadline")}
                        </MotifOption>
                      </MotifSelect>
                    </MotifFormField>
                  </div>
                </div>
                &nbsp;
                <div className="motif-row">
                  <div className="motif-col-sm-3">
                    {dueDate === DueDateType.TimeLimit && (
                      <>
                        <MotifLabel aria-label="Input" for="input">
                          {t("pages.configuration.stages.timeLimitDays")}
                          {handleInformationIcon("timeLimitDays")}
                        </MotifLabel>
                        <MotifFormField aria-label="Input" role="group">
                          {/*@ts-ignore */}
                          <MotifInput
                            onChange={(e: any) => {
                              const value = e.target.value;

                              if (value < 0) {
                                setErrorMessage(
                                  "Time limit days cannot be negative"
                                );
                                return;
                              }
                              setErrorMessage("");
                              let filteredStatuses1 = JSON.parse(
                                JSON.stringify(filteredStatuses)
                              );
                              let json: any = filteredStatuses1?.[index];

                              json.timeLimitDays =
                                value !== "" && value !== undefined
                                  ? value
                                  : null;
                              filteredStatuses1[index] = json;
                              setFilteredStatuses(filteredStatuses1);
                              if (abortController?.abort) {
                                abortController.abort();
                              }
                              clearTimeout(interval);
                              let timeOut = setTimeout(() => {
                                handleInputChange1(json);
                              }, delay);
                              setInterval(timeOut);
                            }}
                            value={
                              filteredStatuses?.[index]?.timeLimitDays
                                ? filteredStatuses?.[index]?.timeLimitDays
                                : ""
                            }
                            type="number"
                            disabled={pageDisable}
                            // onBlur={handleInputChange}
                          />
                        </MotifFormField>
                      </>
                    )}
                    {dueDate === DueDateType.Deadline && (
                      <>
                        <MotifFormField aria-label="Form Field Date Picker">
                          <MotifLabel aria-label="Date">
                            {t("pages.configuration.stages.deadlineDate")}
                            {handleInformationIcon("deadlineDate")}
                          </MotifLabel>
                          <FormattedDatePicker
                            onChange={(value: any) => {
                              handleDateError(value, setErrorMessage);
                            }}
                            value={
                              filteredStatuses?.[index]?.timeLimitDate
                                ? new Date(
                                    filteredStatuses?.[index]?.timeLimitDate!
                                  )
                                : undefined
                            }
                            // onBlur={handleInputChange}
                            // minDate={new Date()}
                            disabled={pageDisable}
                          />
                        </MotifFormField>
                      </>
                    )}
                    <MotifErrorMessage>{errorMessage}</MotifErrorMessage>
                  </div>
                </div>
              </div>
            </div>
          </MotifCardBody>
        </MotifCard>
        {showDeleteSuccessMessage.show && showDeleteSuccessMessage.variant === "status" &&
                    showDeleteSuccessMessage.index === index && (
                      <><br></br><NotificationGrid
                        show={true}
                        message={showDeleteSuccessMessage.message}
                        type={showDeleteSuccessMessage.type}
                        scrollToTop={false}
                        onClose={() =>
                          setShowDeleteSuccessMessage({
                            ...showDeleteSuccessMessage,
                            index: "",
                            show: false,
                            message: "",
                            type: "",
                          })
                        }
                      />
                      </>
                    )}
      </div>

      <CreateEditStatus
        ClaimStatusDefinition={ClaimStatusDefinition}
        show={showCreateStatus}
        setShow={setShowCreateStatus}
        statusData={filteredStatuses?.[index] || statusData}
        isEdit={true}
        getStageData={getStageData}
        numStatuses={0}
        setUpdateMessage={setDeleteErrorMessage}
      />

      <DeleteStageStatus
        show={showDeleteStatus}
        setShow={setShowDeleteStatus}
        id={statusData.id}
        getStageData={getStageData}
        isStage={false}
        selectedStage={selectedStage}
        setSelectedStage={setSelectedStage}
        setDeleteErrorMessage={setDeleteErrorMessage}
        deleteEntityName={deleteEntityName}
        setShowToast={setShowToast}
        showDeleteSuccessMessage={showDeleteSuccessMessage}
        setShowDeleteSuccessMessage={setShowDeleteSuccessMessage}
      />
    </>
  );
}
